import { login, logout } from "../../api/user";
import { getToken, setToken, removeToken } from '@/utils/auth'

const getDefaultState = () => {
    return{
        token: getToken() 
    }
    
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
}

const actions = {
    login( {commit}, userInfo){
        const {mobile, password} = userInfo
        return new Promise((resolve, reject) => {
            login({mobile: mobile.trim(), password: password})
            .then((res) => {
                const {token} = res.data
                commit('SET_TOKEN', token)
                setToken(token)
                resolve()
            })
            .catch(err => {
                reject(error)
            })
        })
    },

    logout({commit}){
        return new Promise((reslove, reject) => {
            logout()
            .then(res => {
                removeToken()
                commit('RESET_STATE')
                reslove()
            })
            .catch(err => {
                reject(err)
            })
        })
    },

     // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
  }


// WEBPACK FOOTER //
// ./src/store/modules/user.js